import {
  createColumnButton,
  createColumnDate,
  createColumnNumber,
  createColumnTag,
  createColumnText,
  formatNumber,
  widthOptions,
} from '../../../components/table/function';
import { GENERATE_STATUS } from '../../../resources/status';

export const columns = ({ onGetQrExcel }) => {
  return [
    createColumnTag(
      'สถานะ',
      { key: 'generateStatus', text: 'generateStatus', icon: true },
      GENERATE_STATUS,
    ),
    createColumnText(
      'สี Qr',
      'nameTh',
      widthOptions(170, {
        render: (_, record) =>
          record?.nameTh
            ? `${record?.nameTh}${record?.categoryCode ? ` (${record?.categoryCode})` : ''}`
            : '',
      }),
    ),
    createColumnNumber(
      'จำนวน QR Code',
      'serialNumberAmount',
      widthOptions(200, { render: (value) => formatNumber(value) }),
    ),
    createColumnText('อีเมล', 'recipientEmail', widthOptions(280)),
    createColumnText('สร้างโดย', 'createBy', widthOptions(150)),
    createColumnButton('Download ข้อมูล QR', 'excel', {
      others: { width: 210 },
      buttonArr: [
        {
          useFor: 'DOWNLOAD_QR',
          onClick: (record) => {
            onGetQrExcel({ periodCode: record?.record?.periodCode });
          },
        },
      ],
    }),
    createColumnDate('วันที่สร้าง', 'createDate', widthOptions(190)),
  ];
};
